// @team Subscriptions - Programs & Upsells

import { Config } from '@bfa/next-app-config';
import { getFirstParam, logError } from '@bfa/nextjs-common/utils';
import {
  DEFAULT_LOGIN_CONFIRMATION_FLOW,
  EMPTY_PAGE_CONTENT_ERROR,
  ERROR_PROPS,
  OWNING_TEAM_NAME,
} from 'features/LoginConfirmation/constants';
import GET_LOGIN_CONFIRMATION_CONTENT from 'features/LoginConfirmation/graphql/queries/GET_LOGIN_CONFIRMATION_CONTENT';
import LoginConfirmation, {
  LoginConfirmationPageProps,
} from 'features/LoginConfirmation/pages';
import flow from 'lodash/flow';
import { NextPage, NextPageContext } from 'next';
import { initApolloClient, withApolloContext } from 'utils/apollo';

import getToggledProgram from '../../utils/cookies/getToggledProgram';

const LoginConfirmationPage: NextPage<LoginConfirmationPageProps> = (props) => (
  <LoginConfirmation {...props} />
);

LoginConfirmationPage.getInitialProps = async (
  ctx: NextPageContext
): Promise<LoginConfirmationPageProps> => {
  try {
    const loginFlow =
      getFirstParam(ctx.query.flow) ?? DEFAULT_LOGIN_CONFIRMATION_FLOW;
    const { data, error } = await loadLoginConfirmationPageContent(
      ctx,
      loginFlow
    );

    if (error) {
      return logAndReturnError(error);
    }

    const { loginConfirmationContent } = data?.me?.layout;

    if (!loginConfirmationContent) {
      return logAndReturnError(`${EMPTY_PAGE_CONTENT_ERROR} ${loginFlow}`);
    }
    return {
      program: getToggledProgram(ctx),
      loginFlow,
      recaptchaEnabled:
        data?.me.recaptchaEnabled &&
        Config.public.misc.googleReCaptchaV3Key !== '',
      title: loginConfirmationContent.title,
      disclaimer: loginConfirmationContent.disclaimer,
      eventLabels: {
        clickstreamViewed: loginConfirmationContent.csviewed,
        clickstreamLogo: loginConfirmationContent.cslogo,
        clickstreamClosed: loginConfirmationContent.csclosed,
      },
      closeTarget: loginConfirmationContent.closetarget,
    };
  } catch (error) {
    return logAndReturnError(error);
  }
};

const logAndReturnError = (error: unknown) => {
  logError(error);
  return ERROR_PROPS;
};

const loadLoginConfirmationPageContent = (
  ctx: NextPageContext,
  loginFlow: string
) => {
  const client = initApolloClient({}, ctx);
  return client.query({
    query: GET_LOGIN_CONFIRMATION_CONTENT,
    variables: {
      loginFlow,
    },
    context: {
      teamName: OWNING_TEAM_NAME,
    },
  });
};

const Page = flow(withApolloContext({ ssr: true }))(LoginConfirmationPage);
Page.displayName = 'LoginConfirmation';

export default Page;
